import { InformationForBorrowingDetailContainer } from "../../../containers/borrowSystem/ProposedToTheSubCommittee/InformationForBorrowingDetailContainer";

export function InformationForBorrowingDetailPage () {

    return(
        <InformationForBorrowingDetailContainer/>
    )
}




